export const BOARD_USERS_PAGE_SIZE_OPTIONS = [10, 15, 20, 25];
export const BOARD_USERS_DEFAULT_PAGE_SIZE = 10;
export const BOARD_USERS_DEFAULT_SORT_COLUMN = 'Position';
export const BOARD_USERS_DEFAULT_SORT_COLUMN_DIRECTION = 'desc';

export enum BOARD_USERS_LISTS_TABLE_COLUMNS {
	NAME = 'Name',
	CREATED_AT = 'CreatedAt',
	ACTIONS = 'Actions'
}
export const BOARD_USERS_LISTS_TABLE_HEADER = [
	BOARD_USERS_LISTS_TABLE_COLUMNS.NAME,
	BOARD_USERS_LISTS_TABLE_COLUMNS.CREATED_AT,
	BOARD_USERS_LISTS_TABLE_COLUMNS.ACTIONS
];

export const BOARD_USERS_LISTS_DEFAULT_SORT_COLUMN = BOARD_USERS_LISTS_TABLE_COLUMNS.CREATED_AT;
export const BOARD_USERS_LISTS_DEFAULT_SORT_COLUMN_DIRECTION = 'desc';
export const BOARD_USERS_LISTS_PAGE_SIZE_OPTIONS = [5, 10];
export const BOARD_USERS_LISTS_PAGE_DEFAULT_SIZE = 5;

export enum ECodeTypes {
	CODE_TYPE_UNKNOWN = -1, // Added 20170809
	CODE_TYPE_KLT = 0x01,
	CODE_TYPE_STRAUSS_KLT = 0x02,
	CODE_TYPE_KEYBOARD = 0x04,
	CODE_TYPE_TRANSPONDER = 0x05,
	CODE_TYPE_TOP = 0x11, // 17
	CODE_TYPE_TAM = 0x12, // 18
	// Motostar codes added 20181205, ask Mario how these must be handled...
	// CODE_TYPE_MOTOSTAR_TOP = 0x21, // 33
	// CODE_TYPE_MOTOSTAR_TAM = 0x22, // 34
	CODE_TYPE_ROLLING = 0x40, // 64
	CODE_TYPE_TWIN_TTS_FIXED = 0x80 // 128
}

export const KEYBOARD_MIN = 0;
export const KEYBOARD_MAX = 99999999;
export const KEYBOARD_MAXLEN = 8; // 20190610

export enum ERemoteModels {
	// Radio
	AT02EV = 'AT02EV',

	AT04EV = 'AT04EV',
	AT02D = 'AT02D',
	AT04D = 'AT04D',
	TOP_432EE = 'TOP-432EE',
	TOP_434EE = 'TOP-434EE',
	TOP_432EV = 'TOP-432EV',
	TOP_434EV = 'TOP-434EV',
	TOP_862EV = 'TOP-862EV',
	TOP_864EV = 'TOP-864EV',
	TOP_862EE = 'TOP-862EE',
	TOP_864EE = 'TOP-864EE',
	TAM_432SA = 'TAM-432SA',
	TOP_432NA = 'TOP-432NA',
	TOP_432S = 'TOP-432S',
	TOP_432A = 'TOP-432A',
	T438 = 'T438',
	WAGNER = 'WAGNER',
	VIVALDI = 'VIVALDI',
	ELVIS = 'ELVIS',
	HENDRIX = 'HENDRIX',
	STRAUSS = 'STRAUSS',

	// Radio keyboards
	S9000 = 'S9000',
	SELT1W4G = 'SELT1W4G',
	SELT1W8G = 'SELT1W8G',

	// Twin
	TW2EE = 'TW2EE',
	TW4EE = 'TW4EE',

	// TTS
	TTS44FKS = 'TTS44FKS', // codici Twin/TTS Fixed Code/New Fixed Code
	TTSD4RKS = 'TTSD4RKS',
	TTS44RKS = 'TTS44RKS',

	// TOP SPORT
	TOP44RBN = 'TOP44RBN', // rolling code
	TOPD4REN = 'TOPD4REN', // rolling code

	TOP42FGN = 'TOP42FGN', // codici Twin/TTS Fixed Code/New Fixed Code
	TOP44FGN = 'TOP44FGN', // codici Twin/TTS Fixed Code/New Fixed Code
	TOPD4FRN = 'TOPD4FRN', // codici Twin/TTS Fixed Code/New Fixed Code

	// Keyboards
	// 20181108: Removed these because they are keyboards, not codes!
	/*S5000 = 'S5000'
	S6000 = 'S6000'
	S7000 = 'S7000'
	SELT1NDG = 'SELT1NDG'
	SELT2NDG = 'SELT2NDG'*/

	// Transponders
	// 20181108: Removed these because are readers, not badges
	/*TSP00 = 'TSP00'
	SELR1NDG = 'SELR1NDG'
	SELR2NDG = 'SELR2NDG'*/
	TST01 = 'TST01',
	MIFARE = 'MIFARE',

	// -------------
	// Added 20170621, these are the new = 'colored' RC, some of them are TOP, some others are rolling
	// code but they all are named as = 'TOP'
	// this has been decided by CAME managers...
	// 3 chars: TOP = Serie
	// 1 char: 4 = 433 MHz, D = Double, 8 = 868 MHz
	// 1 char: Number of buttons
	// 1 char: F = Fixed code, R = Rolling code, T = Twin
	// 1 char: B = Blue, W = White, N = Brown, K = Black, Y = Yellow, G = Grey
	// 1 char: S = Single pack, M = Multi pack

	// Fixed codes (TOP?)
	TOPD2FGS = 'TOPD2FGS',
	TOPD2FBS = 'TOPD2FBS',
	TOPD2FKS = 'TOPD2FKS',
	TOPD2FYS = 'TOPD2FYS',
	TOPD2FES = 'TOPD2FES',
	TOPD2FPS = 'TOPD2FPS',
	// 4 buttons added 20170828
	TOPD4FGS = 'TOPD4FGS',
	TOPD4FBS = 'TOPD4FBS',
	TOPD4FKS = 'TOPD4FKS',
	TOPD4FYS = 'TOPD4FYS',
	TOPD4FES = 'TOPD4FES',
	TOPD4FPS = 'TOPD4FPS',

	// Rolling codes
	TOPD2RGS = 'TOPD2RGS',
	TOPD2RBS = 'TOPD2RBS',
	TOPD2RKS = 'TOPD2RKS',
	TOPD2RYS = 'TOPD2RYS',
	TOPD2RES = 'TOPD2RES',
	TOPD2RPS = 'TOPD2RPS',
	// 4 buttons added 20170828
	TOPD4RGS = 'TOPD4RGS',
	TOPD4RBS = 'TOPD4RBS',
	TOPD4RKS = 'TOPD4RKS',
	TOPD4RYS = 'TOPD4RYS',
	TOPD4RES = 'TOPD4RES',
	TOPD4RPS = 'TOPD4RPS',
	// -------------

	TYPE_TOP = 'TOP',
	TYPE_TAM = 'TAM',
	TYPE_TWIN = 'Twin',
	TYPE_ROLLING = 'Rolling code',
	// Fix translations context
	TYPE_KLT = 'KLT',
	TYPE_STRAUSS_KLT = 'STRAUSS KLT',
	TYPE_TTS_FIXED_CODE = 'New Fixed Code',
}

export const CODE_DIGITS_NUM = 18;
export const MAX_RC_BUTTONS = 4; // For now I assume that each rolling code has a maximum of 4 buttons

// from npm @rd-electronics/user-files
export enum EUserCompatLevel {
	Unknown = -1,
	Compatible = 1,
	Almost = 2,
	Incompatible = 3,
	NeedReverse = 4,
	FixControlItem = 5,
}
